import AttendanceOverview from "./components/attendanceCard";
import CalendarWidget from "./components/calenderCard";
import DashboardCards from "./components/dashboardCards";
import PayrollOverview from "./components/payrollCards";
import StaffList from "./components/staffCards";
import { getDashboardData } from "../../../services/workspace/dashboard.service";
import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import usePusherChannel from "../../../hooks/usePusherChannel";

const Dashboard = () => {
  // Initialize Pusher channel for real-time updates (attendance, etc.)
  usePusherChannel("hr-communication", "PONG_MESSAGE");
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const userProfile = useSelector((state) => state.user.user);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      setLoading(true);
      const response = await getDashboardData();
      setDashboardData(response);
    } catch (error) {
      console.error("Failed to fetch dashboard data:", error);
      toast.error("Failed to load dashboard data");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="p-4 flex flex-col gap-4">
        {/* Skeleton KPI Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
          {[
            "border-l-blue-500",
            "border-l-purple-500",
            "border-l-green-500",
            "border-l-red-500",
          ].map((accent, i) => (
            <div
              key={i}
              className={`p-5 bg-white rounded-xl border border-borderColor border-l-[3px] ${accent} animate-pulse`}
            >
              <div className="flex items-start justify-between">
                <div className="flex-1 space-y-3">
                  <div className="h-3 w-24 bg-gray-200 rounded" />
                  <div className="h-7 w-16 bg-gray-200 rounded" />
                </div>
                <div className="w-11 h-11 rounded-full bg-gray-100" />
              </div>
            </div>
          ))}
        </div>
        {/* Skeleton Charts */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {[1, 2, 3].map((i) => (
            <div key={i} className="bg-white p-5 rounded-xl border border-borderColor animate-pulse">
              <div className="h-4 w-32 bg-gray-200 rounded mb-4" />
              <div className="h-48 bg-gray-50 rounded-lg" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  // Check if user is staff (type === 2)
  const isStaff = userProfile?.type === 2;

  return (
    <div className="p-4 flex flex-col gap-4">
      <DashboardCards data={dashboardData} isStaff={isStaff} />
      <div className={`grid gap-4 ${isStaff ? 'grid-cols-1 lg:grid-cols-2' : 'grid-cols-1 lg:grid-cols-3'}`}>
        <AttendanceOverview data={dashboardData} isStaff={isStaff} />
        {!isStaff && <PayrollOverview data={dashboardData} isStaff={isStaff} />}
        <CalendarWidget />
      </div>
      {!isStaff && <StaffList data={dashboardData} isStaff={isStaff} />}
    </div>
  );
};

export default Dashboard;
